/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutCenterRewards.vue?vue&type=template&id=0321efba&scoped=true"
import script from "./LayoutCenterRewards.vue?vue&type=script&lang=js"
export * from "./LayoutCenterRewards.vue?vue&type=script&lang=js"
import style0 from "./LayoutCenterRewards.vue?vue&type=style&index=0&id=0321efba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321efba",
  null
  
)

export default component.exports